var CartItemSlot;
(function (CartItemSlot) {
    CartItemSlot[CartItemSlot["Primary"] = 0] = "Primary";
    CartItemSlot[CartItemSlot["Secondary"] = 1] = "Secondary";
    CartItemSlot[CartItemSlot["Shipping"] = 2] = "Shipping";
    CartItemSlot[CartItemSlot["ShippingIntl"] = 3] = "ShippingIntl";
    CartItemSlot[CartItemSlot["Trial"] = 4] = "Trial";
    CartItemSlot[CartItemSlot["Subscription"] = 5] = "Subscription";
    CartItemSlot[CartItemSlot["Upsell"] = 6] = "Upsell";
    CartItemSlot[CartItemSlot["SemiAnnual"] = 7] = "SemiAnnual";
})(CartItemSlot || (CartItemSlot = {}));
export default CartItemSlot;
